import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LocalStorageKeys } from 'app/global/storage.service';

export const otpVerificationGuard: CanActivateFn = (route, state) => {
  const router$ = inject(Router);
  const Is2faEnabled = localStorage.getItem(LocalStorageKeys.IS_2FA_ENABLED);
  if(Is2faEnabled === 'true'){
    return true;
  }
  router$.navigate(['/']);
  return false;
};
